import { Component, OnInit, Input, Output, EventEmitter } from '@angular/core';
import { CommonModule } from '@angular/common';
import { Router, RouterModule } from '@angular/router';
import { ClickOutSideDirective } from '../../../../../directives/click-out-side.directive';
import { HttpClient, HttpClientModule, HttpHeaders } from '@angular/common/http';
import { FeatherIconComponent } from '../../../feather-icon/feather-icon.component';
import { NotificationService } from '../../../../../../services/notification.service';
import { SecureStorageService } from '../../../../../../services/secure-storage.service';
import { AuthService } from '../../../../../../services/auth.service';
import { environment } from '../../../../../../../environments/environment';
import { ProfileService } from '../../../../../../services/profile.service';

@Component({
  selector: 'app-user-profile',
  standalone: true,
  imports: [
    CommonModule,
    RouterModule,
    FeatherIconComponent,
    ClickOutSideDirective,
    HttpClientModule
  ],
  providers: [],
  templateUrl: './user-profile.component.html',
  styleUrl: './user-profile.component.scss'
})
export class UserProfileComponent implements OnInit {
  @Input() useMobileMenu = false;
  @Output() userClick = new EventEmitter<void>();

  isOpen = false;
  isAuthenticated = false;
  profil: any;

  @Input() unreadRequestsCount: number = 0;
  @Input() isStar: boolean = false;

  private token = this.secureStorage.getItem<string>('token') || '';
  private baseApiUrl: string = environment.apiUrl;
  private httpOptions = {
    headers: new HttpHeaders({
      'Content-Type': 'application/json',
      'Authorization': `Bearer ${this.token}`
    })
  };

  constructor(
    private notificationService: NotificationService,
    private secureStorage: SecureStorageService,
    private authService: AuthService,
    private http: HttpClient,
    private router: Router,
    private profileService: ProfileService
  ) {}

  ngOnInit() {
    this.isAuthenticated = this.authService.isLoggedIn();
    if (this.isAuthenticated) {
      this.loadUserProfile();
    }
  }

  toggleDropdown(event: Event) {
    event.stopPropagation();
    if (this.useMobileMenu) {
      this.userClick.emit();
      return;
    }
    this.isOpen = !this.isOpen;
  }

  outSideClose() {
    this.isOpen = false;
  }

  onDropdownLinkClick() {
    this.isOpen = false;
  }

  logOut() {
     // Appel à l'API de déconnexion en arrière-plan
     this.http.post(`${environment.apiUrl}/logout`, {}, this.httpOptions)
     .subscribe({
       next: () => {
         console.log('Déconnexion réussie côté serveur');
       },
       error: (error) => {
         console.error('Erreur lors de la déconnexion côté serveur:', error);
       }
     });
   
   // Continuer avec le processus de déconnexion côté client
   localStorage.clear();
   this.isAuthenticated = false;
   this.profileService.resetProfile();
   this.router.navigateByUrl("/auth/login");
  }

  private loadUserProfile() {
    const user = this.secureStorage.getItem('user');
    if (user) {
      this.profil = user as any;
    }
  }
}
